//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LENDER_SUBMISSION_DETAILS, PERSONAL_DETAILS } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InformationFromExpert",
  methods: {
    expertDetails(detailType) {
      switch (detailType) {
        case "lender":
          return LENDER_SUBMISSION_DETAILS();
        case "personal":
          return PERSONAL_DETAILS();
        default:
          return {};
      }
    }
  }
});